export const ADD_BOOKING = "booking/add_booking";
export const REMOVE_BOOKING = "booking/remove_booking";
